export default __webpack_public_path__ + "static/media/qr-step-2.65fdd5a8.svg";